module.exports = __webpack_public_path__ + "static/media/caroline-attwood-E1rH__X9SA0-unsplash.7fa2c146.jpg";